import React from 'react';

/**
 * FormField Component
 * 
 * Standardized form field wrapper with label
 */
export const FormField = ({ label, required, children, hint }) => (
  <div>
    {label && (
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && '*'}
      </label>
    )}
    {children}
    {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
  </div>
);

/**
 * Input Component
 * 
 * Standardized text input field
 */
export const Input = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled = false,
  id,
  ...props
}) => (
  <input
    type={type}
    id={id}
    value={value || ''}
    onChange={onChange}
    placeholder={placeholder}
    disabled={disabled}
    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
    {...props}
  />
);

/**
 * Select Component
 * 
 * Standardized select dropdown
 */
export const Select = ({
  value,
  onChange,
  options = [],
  placeholder,
  disabled = false,
  id,
  renderOption,
  ...props
}) => (
  <select
    id={id}
    value={value || ''}
    onChange={onChange}
    disabled={disabled}
    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
    {...props}
  >
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((option, idx) => {
      if (renderOption) {
        return renderOption(option, idx);
      }
      const optionValue = typeof option === 'object' ? option.value || option.name : option;
      const optionLabel = typeof option === 'object' ? option.label || option.name : option;
      return (
        <option key={idx} value={optionValue}>
          {optionLabel}
        </option>
      );
    })}
  </select>
);

/**
 * Textarea Component
 * 
 * Standardized textarea field
 */
export const Textarea = ({
  value,
  onChange,
  placeholder,
  rows = 3,
  disabled = false,
  id,
  ...props
}) => (
  <textarea
    id={id}
    rows={rows}
    value={value || ''}
    onChange={onChange}
    placeholder={placeholder}
    disabled={disabled}
    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
    {...props}
  />
);

